module.exports = __webpack_public_path__ + "static/media/yoga (1).7e617ea0.svg";